import React from 'react';
import Dialog from 'material-ui/Dialog';
import { API_URL } from './constants/ApiConstants';
import { jsonApiHeader } from '../../../../actions/utilAction';

import SmallLoader from '../../../../img/small-loader.gif';
import { CommonButton } from '../../../../components/buttons';
import UploadDocumentScreen from '../../../../modules/patients/UploadDocumentScreen';

class Upload_ERA_Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isValidFileSize: false,
            fileName: '',
            successMessage: '',
            errorMessage: '',
            response: null,
            file: null , // Initialize file state
            isShowLoder:false
        };
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
    }

    handleClose = () => { // Use arrow function for auto-binding
        this.props.closeDialog();
    }

    handleUploadFile(file) {
        this.setState({isShowLoder:true})
        const selectedFile = Array.isArray(file) && file.length < 2 ? file[0] : null;
        if (selectedFile) {
            this.setState({ file: selectedFile, fileName: selectedFile.name, errorMessage: '', successMessage: '' }); // Set fileName
            this.setState({isShowLoder:false})
        } else {
            console.error("No file selected.");
            this.setState({isShowLoder:false})
        }
    }

    handleUpload() {
        this.setState({isShowLoder:true})
        if (this.state.file !== null) {
            const formData = new FormData();
            formData.append('file', this.state.file);
            const access_token = localStorage.getItem('access_token');

            fetch(`${API_URL}/EDIParser/UploadEDI835`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${access_token}`
                },
                body: formData // Send formData as the body
            })
            .then(response => {
                if (response.ok) { // Check if response is successful
                    return response.json();
                } else {
                    throw new Error('Network response was not ok');
                }
            })
            .then(data => {
                this.setState({
                    response: data,
                    fileName: '', // Reset fileName after successful upload
                    file: null ,// Reset file after successful upload
                    isShowLoder:false
                });
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.response !== prevState.response) {
            if (this.state.response && this.state.response.statusCode === 200) {
                this.setState({
                    successMessage: this.state.response.message,
                    errorMessage: ''
                });
            } else if (this.state.response) {
                this.setState({
                    errorMessage: this.state.response.message,
                    successMessage: ''
                });
            }
        }
    }

    renderLoading() {
        return (
            <div>
                {this.state.isShowLoder ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        return (
            <Dialog
                className="custom_modal"
                title='Upload ERA Document'
                modal={false}
                open={this.props.open} // Use the open prop passed from parent
                autoScrollBodyContent={true}
                // onRequestClose={this.handleClose} // Close the dialog on background click
            >
                {this.renderLoading()}
                <div className="row">
                    <div className="col-sm-6">
                        <form className="readmin-form custom_form">
                            <div className="row">
                                <div className='col-sm-12 require mt-5'>
                                    <p>Files to be Uploaded are:</p>
                                </div>
                            </div>
                            <div className="row">
                                <UploadDocumentScreen open={this.props.open} handleUpload={this.handleUpload} handleUploadFile={this.handleUploadFile} />
                            </div>
                        </form>
                    </div>
                    <div className="col-sm-6">
                        {this.state.fileName && <div className='alert-success mt-15' >Selected file: {this.state.fileName}</div>}
                        {this.state.errorMessage && <div className="alert-danger mt-15"> {this.state.errorMessage || ''} </div>}
                        {this.state.successMessage && <div className="alert-success mt-15">{this.state.successMessage || ''} </div>}
                    </div>
                </div>
                <div className="col-sm-12 pt20 btn_rt">
                    <CommonButton
                        primary={true}
                        className="mr-15"
                        label="Upload"
                        onTouchTap={this.handleUpload}
                        disabled={!this.state.file}
                    />
                    <CommonButton className="ml-15 grey_btn" label="Cancel" onTouchTap={this.handleClose} />
                </div>
            </Dialog>
        );
    }
}

export default Upload_ERA_Modal;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/Upload_ERA_Modal.js